<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-select class="w100" multiple collapse-tags v-model="value" :placeholder="typeData.placeholder ? typeData.placeholder : '请选择' + typeData.label">
          <el-option v-for="(item, index) in typeData.data" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "SelectComp",
  props: ["type-data", "w50", "w100", "width"],
  components: {},
  data() {
    return {
      value: []
    };
  },
  created() {
    // this.value = this.typeData.data.map(v => v.value);
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
